import userInfo from 'hub-http/userInfo';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { gate } from 'hub-http/gates';
const initialState = {
  user: {
    scopes: [],
    email: '',
    locale: ''
  },
  gates: [],
  portal: {}
};

// thunks
export const fetchAuth = createAsyncThunk('auth/initialize', () => userInfo());
const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchAuth.fulfilled, (state, action) => {
      return action.payload;
    });
  }
});
export const {
  name: authName,
  reducer: authReducer
} = auth;

// selectors
export const selectAuthenticatedUser = state => state.auth.user;
export const selectIsUngatedForCaseStudies = gates => gates.includes('StructuredContentPlatform:CaseStudies');
export const selectUserScopes = state => {
  const user = selectAuthenticatedUser(state);
  return user ? user.scopes : [];
};
export const selectIsUngatedForCMPPublicationAPIs = state => {
  const gates = state.auth.gates;
  return gates.includes(gate('CaseStudyEditor:UseCMPPublishAPIs'));
};